import PropTypes from 'prop-types';
import textStyles from 'config/branding/textStyles';
import { styled } from '@activebrands/core-web/libs/styletron';
import getValidationErrorMessage from '@activebrands/core-web/utils/get-validation-error-message';

const ErrorMessages = styled('p', {
    width: '100%',
    marginTop: '4px',
    color: 'var(--color-text-error)',
    ...textStyles['Miscellaneous/10_100'],

    ':before': {
        content: '"*"',
    },
});

const InputErrors = ({ errors, id, role = 'alert', $style, selector }) => {
    const content = errors.map((error, i) => {
        const message = getValidationErrorMessage(error);

        return (
            <ErrorMessages $style={$style} key={i}>
                {message}
            </ErrorMessages>
        );
    });

    if (id || role) {
        return (
            <div data-selector={selector} id={id} role={role}>
                {content}
            </div>
        );
    }

    return content;
};

InputErrors.propTypes = {
    $style: PropTypes.object,
    errors: PropTypes.array.isRequired,
    id: PropTypes.string,
    role: PropTypes.string,
    selector: PropTypes.string,
};

export default InputErrors;
